// Widget-Plugin: Freetext
vcDashboardRegistry.register("freetext", {
    noTitle: false,
    defaults: { w: 8, h: 8, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: true, allowOverlap: true },
    settingsDefaults: { FreeText: "", hideBorder: false },
    get popupTitle() { return vcDashboardResources.get("freetextSettings"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-freetext-wrapper'></div>");
    },
    loadChart: function ($item, settings) {
        var obj = $item.find(".dashboard-freetext-wrapper");
        obj.html(settings.FreeText || "");
        $item.toggleClass("dashboard-item-no-border", !!settings.hideBorder);
    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
    buildFields: function (currentSettings, $el) {
        var fields = [];
        fields.push({ key: "FreeText", label: vcDashboardResources.get("freeText"), type: "richtext", rows: 14 });
        fields.push({ key: "hideBorder", label: vcDashboardResources.get("hideBorder"), type: "checkbox" });
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});